import React, {PureComponent} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import AssignmentsList from "./Assignments/Assignments";
import Form from "./Assignments/Form";
import Spinner from "../UI/Spinner";

class Assignments extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        }
    }

    render() {
        const {
            loading
        } = this.state;

        if (loading) {
            return <Spinner />
        }
        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path="/profile" render={() =>
                            <AssignmentsList />
                        }
                        />
                        <Route exact path="/profile/assignments/add" component={Form}/>
                        <Route exact path="/profile/assignments/edit/:id" component={Form}/>
                    </Switch>
                </div>
            </Router>
        );
    }
}

export default Assignments;
